export { c as createHooksInternal, b as createReactProxyDecoration, a as createReactQueryUtilsProxy } from '../createHooksInternal-026e76a9.mjs';
export { g as getQueryClient } from '../queryClient-4d766c0c.mjs';
import '@trpc/server/shared';
import '@trpc/client';
import '@tanstack/react-query';
import 'react';
import '../getArrayQueryKey-e56d8d64.mjs';
